/* drawer footer mobile version */
document.addEventListener("DOMContentLoaded", function () {
  var footerHeadings = document.querySelectorAll(".footer-section .open_footer");
  footerHeadings.forEach(function (heading) {
    heading.addEventListener("click", function () {
      var ul = this.nextElementSibling;
      if (ul) {
        ul.style.display = ul.style.display === "block" ? "none" : "block";
        var plusIcon = this.querySelector(".icon-plus");
        var minusIcon = this.querySelector(".icon-minus");
        if (ul.style.display === "block") {
          plusIcon.style.display = "none";
          minusIcon.style.display = "block";
        } else {
          plusIcon.style.display = "block";
          minusIcon.style.display = "none";
        }
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var button1 = document.getElementById("mobile_footer_btn_1");
  var button2 = document.getElementById("mobile_footer_btn_2");
  var section1 = document.getElementById("footer_section1");
  var section2 = document.getElementById("footer_section2");
  var icon = document.querySelector(".rotate-icon"); 
  button1.addEventListener("click", function () {
    if (section1.style.display === "block") {
      section1.style.display = "none";
      icon.style.transform = "rotate(0deg)"; 
    } else {
      section1.style.display = "block";
      icon.style.transform = "rotate(180deg)"; 
    }
  });
  button2.addEventListener("click", function () {
    if (section2.style.display === "block") {
      section2.style.display = "none";
      icon.style.transform = "rotate(0deg)"; 
    } else {
      section2.style.display = "block";
      icon.style.transform = "rotate(180deg)"; 
    }
  });
});

/* close button on announcement bar */
const closeX  = document.getElementById('close_announcement');
if(closeX){
closeX.addEventListener('click', function() {
 document.querySelector("#my_utility_bar").style.display = "none"
})}
/* sticky header */
var screenWidth = window.innerWidth;
var headerMenu = document.getElementById("myHeader");
var announcementBar = document.getElementById("myHeader_announcement");
var headerDistance = headerMenu.offsetTop;
var headerDesktop = document.getElementById("first_col_sticky");
var headerDesktopDistance = headerDesktop.offsetTop;
var favHeader = document.getElementById("fav_header");
var iconsHeader = document.getElementById("icons_header");

window.onscroll = function() {myScrollFunction()};

function myScrollFunction(){
if(screenWidth > 1024) {
    if(window.pageYOffset > headerDesktopDistance ) {
      /* if there is an annoucement bar */
     // if(announcementBar) {
    //  announcementBar.classList.add("sticky");
     // headerDesktop.classList.add("sticky_with_anouncement");
     // } else {
        headerDesktop.classList.add("sticky");
     //   }
        headerDesktop.classList.add("fixed_desktop_header")
        favHeader.classList.add("visible_header");
        iconsHeader.classList.add("visible_header");
        } else {
        headerDesktop.classList.remove("sticky_with_anouncement");
        headerDesktop.classList.remove("sticky");
        headerDesktop.classList.remove("fixed_desktop_header")
        favHeader.classList.remove("visible_header");
        iconsHeader.classList.remove("visible_header");
     // if(announcementBar) {
     //   announcementBar.classList.remove("sticky");
     // }
        }
  } else {
  if (window.pageYOffset > headerDistance) {
  headerMenu.classList.remove("sticky");
  } else {
  headerMenu.classList.remove("sticky");
    }
  }
}

/* function to add all items to cart */
function addAllItems(array, btnId) {
  var newVariantIdArray = array.split(',');
  var product_data = newVariantIdArray.map(variantId => {
    if (variantId !== "") {
       return {quantity: 1, id: variantId}
    }
  });
  
  var productsToAdd = {
    items: product_data
  };
  fetch('/cart/add.js', {
    body: JSON.stringify(productsToAdd),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    method: 'POST'
  })
  .then((response) => {
    spinnerLoading(btnId);
    return response.json();
  })
  .then((json) => {
const cartNotification = document.querySelector('cart-notification');
     updateThirdPartyCartFn(productsToAdd);
    if (cartNotification) {
      cartNotification.fillCartContent(json.items);
      cartNotification.open();
    }
  })
  .catch((err) => {
    console.error(err);
  });
}

function spinnerLoading(btnId) {
  const x = "spanButton-"
  var button_id = x.concat("", btnId);
  var myButton = document.getElementById(button_id);
  var spinnerDiv = myButton.querySelector('.loading-overlay__spinner');
  var spinnerSpan = myButton.querySelector('.span_button');
  spinnerDiv.classList.remove('hidden');
  spinnerSpan.classList.add('hidden');
  setTimeout(() => {
    spinnerDiv.classList.add('hidden')
    spinnerSpan.classList.remove('hidden');
  }, 2000);
}
function updateCartCount(carttext) {
  var cart_count_span = document.getElementById('data-header-cart-count');
  var cart_count_bubble = document.getElementById('cart-icon-bubble');
 if (cart_count_span === null) {
   cart_count_bubble.innerHTML = 
     '<img src="//cdn.shopify.com/s/files/1/0574/7307/3302/files/cart_black.png?v=1653640382&amp;width=30" class="hover_social_icons" loading="lazy" width="25" height="25" alt="">' +
     '<div class="cart-count-bubble">' + 
     '<span id="data-header-cart-count" aria-hidden="true">' + carttext +
     '</span></div>'
   } else {
     cart_count_span.innerHTML = carttext;
  }
}

function updateNewHead (newCount) {
  var cart_count_span_sticky = document.getElementById('data-header-cart-count-sticky');
  var cart_count_bubble_sticky = document.getElementById('cart-icon-bubble-sticky');
  
if (cart_count_span_sticky === null) {
   cart_count_bubble_sticky.innerHTML = 
     '<img src="//cdn.shopify.com/s/files/1/0574/7307/3302/files/cart_black.png?v=1653640382&amp;width=30" class="hover_social_icons" loading="lazy" width="25" height="25" alt="">' +
     '<div class="cart-count-bubble-sticky">' + 
     '<span id="data-header-cart-count-sticky" aria-hidden="true">' + newCount +
     '</span></div>'
   } else {
     cart_count_span_sticky.innerHTML = newCount;
  }
}

function updateThirdPartyCartFn(productData) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      var carttext = cart.item_count;
      updateCartCount(carttext);
      updateNewHead(carttext)
    })
    .catch(error => {
      console.error('Erreur lors de la récupération des données du panier :', error);
    });
}

// Fonction pour récupérer le nombre de produits dans le panier
function getCartItemCount() {
  return new Promise(function(resolve, reject) {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        updateNewHead(data.item_count);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

/* méthodes pour mettre à jour le nombre de produit dans le panier de l'icone du menu qui est figé au scroll */
(function () {
  if (!window || !window.Shopify) return;

  const CartEvents = {
    add: "SCE:add",
    change: "SCE:change",
  };

  const ShopifyCartURLs = [
    "/cart/add",
    "/cart/change",
    "/cart/add.js",
    "/cart/change.js",
  ];

  function isShopifyCartURL(url) {
    if (!url) return false;
    const path = url.split("/").pop();
    return ShopifyCartURLs.includes(`/cart/${path}`);
  }

  function updateType(url) {
    if (!url) return false;
    if (url.includes("cart/add")) {
      return "add";
    } else if (url.includes("cart/change")) {
      return "change";
    } else return false;
  }

  function dispatchEvent(url, detail) {
    if (typeof detail === "string") {
      try {
        detail = JSON.parse(detail);
      } catch {}
    }

    window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
    const type = updateType(url);
    switch (type) {
      case "add":
        getCartItemCount();
        window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
        break;
      case "change":
        getCartItemCount();
        updateTotalEcoPart();
        window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
        break;
      default:
        break;
    }
  }

  function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
      const url = arguments[1];
      this.addEventListener("load", function () {
        if (isShopifyCartURL(url)) {
          dispatchEvent(url, this.response);
        }
      });
      return originalOpen.apply(this, arguments);
    };
  }

  function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== "function") return;
    const originalFetch = window.fetch;
    window.fetch = function () {
      const response = originalFetch.apply(this, arguments);

      if (isShopifyCartURL(arguments[0])) {
        response.then((res) => {
          res
            .clone()
            .json()
            .then((data) => dispatchEvent(res.url, data));
        });
      }

      return response;
    };
  }

  fetchOverride();
  XHROverride();
})();

/* hotspots */
function toggleHotspot() {
  var cardElements = document.querySelectorAll('.select_card');
  var svgElements = document.querySelectorAll('.select_svg');

  svgElements.forEach(function(svgIcon) {
    if (svgIcon.classList.contains('svg_open')) {
      svgIcon.classList.remove('svg_open');

      var width, height;

      // Vérification de la présence d'un élément spécifique dans le DOM
      var isCollectionTemplate = document.querySelector('.hotspot_collection_section') !== null;

      if (isCollectionTemplate) {
        width = 16;
        height = 16;
      } else {
        width = 24; 
        height = 24;
      }

      svgIcon.innerHTML = `
        <svg id="pin-{{ section.id }}_{{ block.id }}" class="pulse hotspot_svg pins-{{ section.id }}_{{ block.id }}" width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 485 485" style="enable-background:new 0 0 485 485;" xml:space="preserve">
           <path d="M414.012,70.988C368.234,25.211,307.324,0,242.5,0S116.766,25.211,70.988,70.988C25.211,116.766,0,177.677,0,242.5   s25.211,125.734,70.988,171.512C116.766,459.789,177.676,485,242.5,485s125.734-25.211,171.512-70.988   C459.789,368.234,485,307.323,485,242.5S459.789,116.766,414.012,70.988z M242.5,455C125.327,455,30,359.673,30,242.5   S125.327,30,242.5,30S455,125.327,455,242.5S359.673,455,242.5,455z" fill="#fe5c01"></path>
          <circle cx="242.5" cy="242.5" r="100.6" fill="#ffffff" stroke="#6f6d6d" stroke-width="20"></circle>
        </svg>
      `;
    }
  });

  cardElements.forEach(function(card) {
    if (card.classList.contains('active_card')) {
      card.classList.remove("active_card");
      card.classList.add("hidden");
    }
  });
}


function displayHotspotCard(hotspotId, collectionHotspot) {
  var cardClass = ('hotspot_card_');
  var svgClass = ('svg-container_')
  if(collectionHotspot) {
    var classCard = cardClass.concat(collectionHotspot)
    var classCardAnd = classCard.concat("_");
    var cardId = classCardAnd.concat(hotspotId);
    var cardToOpen = document.getElementById(cardId);
  } else {
    var cardId = cardClass.concat(hotspotId);
    var cardToOpen = document.getElementById(cardId);
  }
  var svgToChange = svgClass.concat(hotspotId);
  var mySvg = document.getElementById(svgToChange);
  toggleHotspot();
  cardToOpen.classList.remove("hidden");
  cardToOpen.classList.add("active_card");
  mySvg.classList.add("svg_open");
  mySvg.innerHTML = `
     <svg id="pin-{{ section.id }}-{{ forloop.index }}" class="hotspot_svg pins-{{ section.id }}-{{ forloop.index }}" style="background-color: white; border: solid 1px #fe5c01; border-radius: 50%;" 
      width="24" height="24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 485 485" style="enable-background:new 0 0 485 485;" xml:space="preserve">
      <circle cx="242.5" cy="242.5" r="50.6" fill="#6f6d6d"></circle>
    </svg>
  `;
}
function closeHotspotCard() {
  var cardClass = ('select_card');
  toggleHotspot();
}
function displayMiniCart(myId) {
  var myMiniCard = document.getElementById(myId);
  if (window.innerWidth > 990) {
    myMiniCard.style.display= "flex";
    }
}
function hideMiniCart(myId) {
  var myMiniCard = document.getElementById(myId);
  myMiniCard.style.display= "none";
}

/* inverse Selection Potiron et Potiron s'engage sur v.mobile */
if (window.innerWidth < 990) {
  const section1 = document.getElementById("shopify-section-template--20180312752456__aea82f6e-9b31-46ef-bd80-a59cec147a3f"); /* commitment section */
  const section3 = document.getElementById("shopify-section-template--20180312752456__0b3df737-8a1e-49b3-9c8a-978e488cba26"); /* selection section */
  if (section1 && section3) {
    section1.parentNode.insertBefore(section3, section1);
  }
}

/* Slider comment and press */

const sliderCpn = document.querySelector('.slider_cpn');
const sliderCpnCom = document.querySelector('.slider_cpn_com');

const prevBtnCpn = document.getElementById('prevBtn_cpn');
const nextBtnCpn = document.getElementById('nextBtn_cpn');
const dots = document.querySelectorAll('.dot_cpn');
const prevBtnCpnComm = document.getElementById('prevBtn_cpn_comment');
const nextBtnCpnComm = document.getElementById('nextBtn_cpn_comment');
const dotsComm = document.querySelectorAll('.dot_cpn_comment');

let currentIndexCpn = 0;
let currentIndexCpnComm = 0;

const cardsCpn = document.querySelectorAll('.press_article_card');
const cardsCpnComment = document.querySelectorAll('.comment_card');

function updateSliderCpn() {
  // let cardWidth = 360;
  let cardWidth = 555;
  if (window.innerWidth >= 2000) {
    // cardWidth = 505; 
    cardWidth = 778;
  }
  const offsetCpn = -currentIndexCpn * cardWidth;
  if (sliderCpn) {
    sliderCpn.style.transform = `translateX(${offsetCpn}px)`;
  }

  if (dots) {
    dots.forEach((dot, index) => {
      if (index === currentIndexCpn) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  if (prevBtnCpn) {
    prevBtnCpn.disabled = currentIndexCpn === 0;
  }

  if (nextBtnCpn) {
    nextBtnCpn.disabled = currentIndexCpn === cardsCpn.length - 1;
  }
}

function updateSliderCpnComm() {
  // let cardWidth = 360;
  let cardWidth = 555;
  if (window.innerWidth >= 2000) {
    // cardWidth = 505; 
    cardWidth= 778;
  }
  const offsetCpnComm = -currentIndexCpnComm * cardWidth;
  if (sliderCpnCom) {
    sliderCpnCom.style.transform = `translateX(${offsetCpnComm}px)`;
  }

  if (dotsComm) {
    dotsComm.forEach((dot, index) => {
      if (index === currentIndexCpnComm) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  if (prevBtnCpnComm) {
    prevBtnCpnComm.disabled = currentIndexCpnComm === 0;
  }

  if (nextBtnCpnComm) {
    nextBtnCpnComm.disabled = currentIndexCpnComm === cardsCpnComment.length - 1;
  }
}

if (nextBtnCpn) {
  nextBtnCpn.addEventListener('click', () => {
    if (currentIndexCpn < cardsCpn.length - 1) {
      currentIndexCpn++;
      updateSliderCpn();
    }
  });
}

if (prevBtnCpn) {
  prevBtnCpn.addEventListener('click', () => {
    if (currentIndexCpn > 0) {
      currentIndexCpn--;
      updateSliderCpn();
    }
  });
}

if (dots) {
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentIndexCpn = index;
      updateSliderCpn();
    });
  });
}

if (nextBtnCpnComm) {
  nextBtnCpnComm.addEventListener('click', () => {
    if (currentIndexCpnComm < cardsCpnComment.length - 1) {
      currentIndexCpnComm++;
      updateSliderCpnComm();
    }
  });
}

if (prevBtnCpnComm) {
  prevBtnCpnComm.addEventListener('click', () => {
    if (currentIndexCpnComm > 0) {
      currentIndexCpnComm--;
      updateSliderCpnComm();
    }
  });
}

if (dotsComm) {
  dotsComm.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentIndexCpnComm = index;
      updateSliderCpnComm();
    });
  });
}

updateSliderCpn();
updateSliderCpnComm();

/* back to top */
(function() {
  function trackScroll() {
    var scrolled = window.pageYOffset;
    var coords = 300; 
    var windowHeight = window.innerHeight;
    var pageHeight = document.body.clientHeight;
     var fixedButtons = document.querySelector("#fixed_buttons")
 
    
    if (scrolled > coords && (pageHeight - scrolled - windowHeight) > 70 * 16) {
      goTopBtn.classList.remove('hide');
    } else {
      goTopBtn.classList.add('hide');
    }
    
//next and previous button on blog article
    if(fixedButtons) {
       if (scrolled > 670 && (pageHeight - scrolled - windowHeight) > 80 * 16) {
         fixedButtons.classList.remove('hide');
       } else {
         fixedButtons.classList.add('hide');
       }
    }
  }

  function backToTop() {
    if (window.pageYOffset > 0) {
      window.scrollBy(0, -80);
    }
  }

  var goTopBtn = document.querySelector('.back-to-top');
  window.addEventListener('scroll', trackScroll);
  goTopBtn.addEventListener('click', backToTop);
})();

/* update Eco participation et économie réalisée */
function updateTotalEcoPart() {
  var inputs = document.querySelectorAll('.eco_part');
  var priceInputs = document.querySelectorAll('.price_for_reduction');
  var totalCartDiv = document.querySelector('#my_total_cart');
  if(totalCartDiv) {
    var totalCart = totalCartDiv.innerText.replace(".","");
    var priceToPay = parseFloat(totalCart);
  }
  var totalOrignalPrice= 0;

  priceInputs.forEach(function(price) {
     var priceInputValue = parseFloat(price.value);
     totalOrignalPrice += priceInputValue;
  })
  var totalOrignalPrice = totalOrignalPrice / 100;
  var totalReduce = Math.round((totalOrignalPrice - priceToPay) * 100 / totalOrignalPrice );
  var economy = totalOrignalPrice - priceToPay;
  var sumEcoPart = 0;
  var totSubVal = document.querySelector('.totals__subtotal-value');
  inputs.forEach(function(input) {
    var totEcoPartValue = parseFloat(input.value);
    sumEcoPart += totEcoPartValue;
  });
  var divEcoPart = document.getElementById('divEcoPart');
  var divReduction = document.getElementById('divReduction');
  var reducePart = document.getElementById('reducePart');
  if(reducePart){
    if(totalReduce === 0) {
      reducePart.style.display="none";
    } else {
      reducePart.style.display="flex";
      divReduction.textContent = economy + "€ (" + totalReduce + "%)";
    }
  }
  if(totSubVal) {
    var cartTotalEco = parseFloat(totSubVal.dataset.cartTotaleco);
  }
  if (divEcoPart) {
    const decim = sumEcoPart.toFixed(2);
    const finalEcoPart = parseFloat(decim).toLocaleString();    
    const finalEcoPartWithPoint = finalEcoPart.replace(",", ".");
    divEcoPart.textContent = finalEcoPartWithPoint + "€";
    var ecoPartContainer = document.getElementById('ecoPart');
    if (sumEcoPart !== 0) {
      ecoPartContainer.style.display = 'flex';
    } else {
      ecoPartContainer.style.display = 'none';
    }
  }
}

updateTotalEcoPart();

/*related product*/
var childElement = document.querySelector('.related_products_section');
if (childElement) {
  var parentElement = childElement.parentNode;
  parentElement.classList.add('my_custom_related_products');
}

/* filter modal */



/* collection description on mobile / readmore */

function showReadMore() {
    var elementsToToggle = document.querySelectorAll('.read-more-content');
    var readMoreButton = document.querySelector('.read-more');
    var readLessButton = document.querySelector('.read-less');
    var text_to_hide = document.querySelector('.hide_section');
  
    if(readMoreButton.style.display = 'flex') {
      text_to_hide.style.display = 'block';
      elementsToToggle.forEach(function(element) {
        element.style.display= 'block';
      });
      readMoreButton.style.display = 'none';
      readLessButton.style.display = 'flex';
    }
}
function hideReadMore() {
   var elementsToToggle = document.querySelectorAll('.read-more-content');
    var readMoreButton = document.querySelector('.read-more');
    var readLessButton = document.querySelector('.read-less');
    var text_to_hide = document.querySelector('.hide_section');
      text_to_hide.style.display = 'none';
  
  elementsToToggle.forEach(function(element) {
        element.style.display= 'none';
       });
       readLessButton.style.display= 'none';
       readMoreButton.style.display= 'flex';
       readMoreButton.scrollIntoView({ behavior: 'smooth' });
}

 document.addEventListener('DOMContentLoaded', function () {
    var secondH2 = document.querySelectorAll('.h2_desc_collection')[1];
    var readMoreButton = document.createElement('div');
    readMoreButton.className = 'read-more';
    readMoreButton.innerHTML = '<a onclick="showReadMore()" class="my_custom_underline_button"><span>Lire la suite</span></a>';
     if(secondH2) {
      secondH2.parentNode.insertBefore(readMoreButton, secondH2.nextSibling);
     }
    var parentElement = document.querySelector('.bg_description_collection');
    var readLessButton = document.createElement('div');
    readLessButton.className = 'read-less';
    readLessButton.innerHTML = '<a onclick="hideReadMore()" class="my_custom_underline_button"><span>Voir moins</span></a>';
   if(parentElement){
    parentElement.appendChild(readLessButton);
   }
   

     
    const premierTdImpaire = document.querySelector('.impaire_td');
   if(premierTdImpaire){
    const tousLesP = premierTdImpaire.querySelectorAll('p');
    var pToToggle = Array.from(tousLesP).slice(1);
    pToToggle.forEach(function (p) {
        p.classList.add('read-more-content');
    });
   }
    var allTDs = document.querySelectorAll('tr');
    var tdToToggle = Array.from(allTDs).slice(1);
    tdToToggle.forEach(function (td) {
        td.classList.add('read-more-content');
    });
  });

/* open social network in new tab */
const links = document.links; 
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) { 
    if (links[i].hostname !== window.location.hostname) { 
      links[i].target = '_blank'; 
      links[i].rel = 'noreferrer noopener'; 
  } 
}

/* anchor certif */

function centrerAncres(cibleID) {
    var cible = document.getElementById(cibleID);
    if (cible) {
        var hauteurPage = document.body.scrollHeight;
        var positionAncre = cible.getBoundingClientRect().top + 200;
        var positionVerticale = window.scrollY + positionAncre - (window.innerHeight / 2);
      setTimeout(function() {
        window.scrollTo({ top: positionVerticale, behavior: 'smooth' });
      }, 1000);
    }
}

document.addEventListener("DOMContentLoaded", function() {
  function getHash() {
    return window.location.hash.substr(1);
  }
  function activateBlock(hash) {
    const block = document.getElementById(hash);
    if (block) {
      document.querySelectorAll('.certification_description_container').forEach(function(elem) {
        elem.classList.remove('active_certif');
      });
      block.classList.add('active_certif');
      document.querySelectorAll('.certif_item').forEach(function(item) {
        item.classList.remove('active');
      });
      const myItem = hash.substr(7);
      const base = 'item-'
      const myConcatItem = base.concat(myItem);
      const linkedItem = document.getElementById(myConcatItem);
      if (linkedItem) {
        linkedItem.classList.add('active');
      }
      centrerAncres(myConcatItem);
    }
  }
  activateBlock(getHash());
  window.addEventListener("hashchange", function() {
    activateBlock(getHash());
  });
});

/* b2b registration AND b2b update delivery preferences display or not palette form */
const deliveryPaletteCheckbox = document.getElementById('RegisterForm-delivery-palette');
const paletteSection = document.getElementById('palette_options_section');

if (deliveryPaletteCheckbox && paletteSection) {
  if (!deliveryPaletteCheckbox.checked) {
    paletteSection.style.display = "none";
  }

  deliveryPaletteCheckbox.addEventListener('change', function() {
    if (this.checked) {
      paletteSection.style.display = "block";
    } else {
      paletteSection.style.display = "none";
    }
  });
}

